import { render } from "./WalletReplaceModal.vue?vue&type=template&id=b3e73178&ts=true"
import script from "./WalletReplaceModal.vue?vue&type=script&lang=ts"
export * from "./WalletReplaceModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__